<template>
<div class="bg" v-show="show">
  <div class="compose">
    <img src="@assets/img/common/close.svg" alt="close" class="close" @click="close()">
    <voiceCompose ref="voiceCompose" v-on:composeComplete="complete"  />
  </div>
</div>
</template>

<script>
import voiceCompose from '@components/voiceCompose/voiceCompose'
import common from '@common/common'
import {apis} from '@common/config'
export default {
  components: {
    voiceCompose
  },
  data() {
    return {
      show: false,
      composeConfig: {},
      config: ''
    }
  },
  methods: {
    open(config) {
      this.config = config;
      config.article = common.cleanHtmlTags(config.article)
      config.article = common.escapeEscapes(config.article) 
      console.log('语音合成模块数据', config)
      this.composeConfig = config
      this.$refs.voiceCompose.soundlist(config)

      this.show = true
    },
    close() {
      this.show = false
    },
    complete(r) {
      // 接到回调，通知后台
      // console.log('callback', r)
      // return false;
      if(this.config.makeup_audio_version == 1){
        if (r.res) {
          if (r.res.code != 1) {
            this.$toast(r.res.msg)
            this.show = false
            return
          }
          this.show = false
          const info = {
            task_id: r.res.task_id,
            objid: this.composeConfig.page_id,
            objtype: this.composeConfig.page_type,
            spd: r.res.spd
          }
          common.myFetch(apis.File_composite_callback, info)
          .then((r) => {
            if (r) {
              // this.$toast(r)
              this.$success({
                title: r,
                detail: '稍后请在多媒体库的音频列表中查看新合成的'
              })
            }
          })
        }
      }else{
        if (r) {

          this.show = false

          const info = {
            title: r.title,
            content: r.content,
            objid: this.composeConfig.page_id,
            objtype: this.composeConfig.page_type,
            spd: r.spd,
            vid: r.vid
          }

          common.myFetch(apis.File_composite_callbackhd, info)
          .then((r) => {
            if (r) {
              // this.$toast(r)
              this.$success({
                title: r,
                detail: '稍后请在多媒体库的音频列表中查看新合成的'
              })
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1007;
    display: flex;
    justify-content: center;
    align-items: center;
    .compose {
      width: 1190px;
      height: 650px;
      position: relative;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: -70px auto 0;
      // margin-top: -70px;
      .close {
        position: absolute;
        right: 30px;
        top: 27px;
        z-index: 10;
        cursor: pointer;
      }
    }
  }
</style>